module.exports = __webpack_public_path__ + "images/emoji/libra.1c2f3cff57f4ed1fab1c.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/libra.png
// module id = LTCd
// module chunks = 24